/**
 * ============================================================================
 * ProgramListingSection (MVC feature barrel)
 * ============================================================================
 * Public entry kept at ProgramListingSection.tsx so /programs imports stay
 * stable.
 *
 * Wire: page → SectionErrorBoundary → controller → view
 * Re-render: memo cards/filters + useCallback handlers in controller
 * ============================================================================
 */
"use client";

import { SectionErrorBoundary } from "@/components/common/ErrorBoundary";
import { useProgramListingController } from "./controller/useProgramListingController";
import ProgramListingSectionView from "./view/ProgramListingSectionView";
import type { ProgramListingSectionProps } from "./model/programListing.types";

export type {
  ProgramListingSectionProps,
  Program,
  ProgramListingSectionViewModel,
} from "./model/programListing.types";

function ProgramListingSectionInner(props: ProgramListingSectionProps) {
  const viewModel = useProgramListingController(props);
  return <ProgramListingSectionView {...viewModel} />;
}

export default function ProgramListingSection(
  props: ProgramListingSectionProps,
) {
  return (
    <SectionErrorBoundary sectionName="ProgramListingSection">
      <ProgramListingSectionInner {...props} />
    </SectionErrorBoundary>
  );
}
